import React, { useEffect, useState } from "react";
import { Select, Input, Button } from "antd";
import { useGET } from "@API2";
import debounce from "lodash/debounce";

const { Option } = Select;

const AutoComplete = (props) => {
  const [searchText, setSearchText] = useState("");
  const [apiKey, setApiKey] = useState(null);
  const { data = [], loading, error } = useGET(props.url, apiKey);
  const [visibleSearchBox, setVisibleSearchBox] = useState(
    props.selectedname ? false : true
  );

  useEffect(() => {
    const params = props.params;
    setApiKey(params.replace(props.replacekey, searchText));
  }, [props, searchText]);

  if (error) return "Liste alınamadı.";

  if (!visibleSearchBox) {
    return (
      <>
        <Input disabled value={props.selectedname} style={{ width: "75%" }} />
        <Button
          type="link"
          onClick={() => {
            props.onChange(null);
            setVisibleSearchBox(true);
          }}
        >
          Değiştir
        </Button>
      </>
    );
  }

  return (
    <Select
      loading={loading}
      {...props}
      placeholder={props.placeholder}
      allowClear
      onClear={() => setSearchText("")}
      showSearch
      filterOption={false}
      onSearch={debounce((a) => setSearchText(a), 500)}
    >
      {data.map((item, index) => {
        if (!item[props.selectedvalue || "id"]) {
          return null;
        }
        return (
          <Option key={index} value={item[props.selectedvalue || "id"]}>
            {props.label.map((x) => (item[x] ? `${item[x]} ` : ""))}
          </Option>
        );
      })}
    </Select>
  );
};

export default AutoComplete;
